import { combineReducers } from 'redux';
import authReducer from './authReducer';
import errorReducer from './errorReducer';
import profileReducer from './profileReducer';
import platformReducer from './platformReducer';
import userOperationReducer from './userOperationReducer';
import autoReducer from './autoReducer';
import dashboardReducer from './dashboardReducer';
import projectReducer from './ProjectReducer';
import TransOperationReducer from './TransOperationReducer';
import EditTableReducer from './EditTableReducer';
import findReducer from './FindReducer';
import videoPlayerReducer from './videoPlayerReducer';
import ViewReducer from './ViewReducer';
import frameControlReducer from './FrameControlReducer';
import TimeshiftReducer from './TimeshiftReducer';
import DragReducer from './DragReducer';

export default combineReducers({
    auth: authReducer,
    errors: errorReducer,
    profile: profileReducer,
    platform: platformReducer,
    userOperation:userOperationReducer,
    auto:autoReducer,
    dashboard:dashboardReducer,
    project:projectReducer,
    transOperation:TransOperationReducer,
    editTable:EditTableReducer,
    videoPlayer:videoPlayerReducer,
    findOperation:findReducer,
    viewOperation:ViewReducer,
    frameControl:frameControlReducer,
    timeshift:TimeshiftReducer,
    drag:DragReducer
});



// WEBPACK FOOTER //
// ./src/reducers/index.js